<template>
	<el-drawer :modal="false"  title="Filter" :visible.sync="showDrawer" class="drawer-filter-initial-proposal" size="20%">
		<b-container>
			<b-row class="text-end">
				<b-col cols="12">
					<div class="d-flex justify-content-end">
						<b-button variant="primary" @click="resetFilter">Reset</b-button>
					</div>
				</b-col>
			</b-row>
			<b-row>
			<!-- Proposal ID -->
			<b-col cols="12">
				<b-form-group label="Filter By Proposal ID">
					<el-input v-model="filters.psal_id" type="number" placeholder="Insert some number" @input="debouncedHandler"></el-input>
				</b-form-group>
			</b-col>

			<!-- Customer Profile ID -->
			<b-col cols="12">
				<b-form-group label="Filter By Customer ID">
					<el-input v-model="filters.psal_customer_id" type="number" placeholder="Insert some number"  @input="debouncedHandler"></el-input>
				</b-form-group>
			</b-col>

			<!-- Customer Profile Name -->
			<b-col cols="12">
				<b-form-group label="Filter By Customer Name">
					<el-input v-model="filters.psal_customer_json" placeholder="Insert some name"  @input="debouncedHandler"></el-input>
				</b-form-group>
			</b-col>

			<!-- Product -->
			<b-col cols="12">
				<b-form-group label="Filter By Product Type">
					<el-select v-model="filters.pcp_product_type" prompt="All Product Type" @change="searchByFilter" filterable>
						<el-option v-for="(item,index) in filterOptionProductType" :key="index" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</b-form-group>
			</b-col>

			<!-- Property Unit No. -->
			<b-col cols="12">
				<b-form-group label="Filter By Property Unit No">
					<el-input v-model="filters.pcp_project_unit_no" placeholder="Insert unit number"  @input="debouncedHandler"></el-input>
				</b-form-group>
			</b-col>

			<!-- Lead Owner ID -->
			<b-col cols="12">
				<b-form-group label="Filter By Lead Owner">
					<el-select v-model="filters.psal_se_id" prompt="All Lead Owner" @change="searchByFilter" filterable>
						<el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</b-form-group>
			</b-col>

			<!-- SSA -->
			<b-col cols="12">
				<b-form-group label="Filter By SSA">
					<el-select v-model="filters.psal_ssa_id" prompt="All SSA" @change="searchByFilter" filterable>
						<el-option v-for="(item,index) in userSsaList" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</b-form-group>
			</b-col>

			<!-- SSA MGR -->
			<b-col cols="12">
				<b-form-group label="Filter By SSA Manager">
					<el-select v-model="filters.psal_approved_ssa_by" prompt="All SSA Manager" @change="searchByFilter" filterable>
						<el-option v-for="(item,index) in filterOptionSSAMgr" :key="index" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</b-form-group>
			</b-col>


			<!-- Credit MGR -->
			<b-col cols="12">
				<b-form-group label="Filter By Credit Manager">
					<el-select v-model="filters.psal_approved_cc_by" prompt="All Credit Manager" @change="searchByFilter"
						filterable>
						<el-option v-for="(item,index) in filterOptionCC" :key="index" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</b-form-group>
			</b-col>

			<!-- Credit Head -->
			<b-col cols="12">
				<b-form-group label="Filter By Credit Head">
					<el-select v-model="filters.psal_approved_ch_by" prompt="All Credit Head" @change="searchByFilter"
						filterable>
						<el-option v-for="(item,index) in filterOptionCH" :key="index" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</b-form-group>
			</b-col>


			<!-- Status -->
			<b-col cols="12">
				<b-form-group label="Filter By Status">
					<el-select v-model="filters.psal_main_status" prompt="All Status" @change="searchByFilter" filterable>
						<el-option v-for="(item,index) in filterOptionStatus" :key="index" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</b-form-group>
			</b-col>

			<!-- Created By -->
			<b-col cols="12">
				<b-form-group label="Filter By Created By">
					<el-select v-model="filters.psal_created_by" prompt="All Creator" @change="searchByFilter" filterable>
						<el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</b-form-group>
			</b-col>

			<!-- Created Date -->
			<b-col cols="12">
				<b-form-group label="Filter By Created Date">
					<el-date-picker
						v-model="filters.psal_created_date_range"
						type="daterange"
      			range-separator="-"
						start-placeholder="Start date"
						end-placeholder="End date"
						value-format="yyyy-MM-dd"
						class="w-100"
						@change="searchByFilter">
					</el-date-picker>
				</b-form-group>
			</b-col>

			<!-- Created Date -->
			<b-col cols="12">
				<b-form-group label="Filter By Approved Date">
					<el-date-picker
						v-model="filters.psal_approved_date_range"
						type="daterange"
      			range-separator="-"
						start-placeholder="Start date"
						end-placeholder="End date"
						value-format="yyyy-MM-dd"
						class="w-100"
						@change="searchByFilter">
					</el-date-picker>
				</b-form-group>
			</b-col>
				
			</b-row>
		</b-container>

	</el-drawer>
</template>
<script>
import { Input, Button, Drawer, Select, Option, DatePicker } from 'element-ui'
import { debounce } from '@/assets/js/httpImports.js'
import { mapActions, mapState } from 'pinia'
import { useInitialProposalStore } from '@/stores/initialProposalStore'
import { useAccessControlStore } from '@/stores/accessControlStore'
import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'

export default {
	name: 'drawer-filter-initial-proposal',
	props: {},
	components: {
		[Input.name]: Input,
		[Button.name]: Button,
		[Drawer.name]: Drawer,
		[Select.name]: Select,
		[Option.name]: Option,
		[DatePicker.name]: DatePicker,
	},
	mounted() {
		this.debouncedHandler = debounce(() => {
			this.searchByFilter();
		}, 500);
	},
	data() {
		return {
			showDrawer: false,
			filters: {
				psal_id: '',
				psal_customer_id: '',
				psal_customer_json: '',
				psal_se_id: '',
				psal_ssa_id: '',
				psal_ssa_mgr_by: '',
				psal_cc_by: '',
				psal_ch_by: '',
				psal_main_status: '',
				psal_created_by: '',
				psal_created_date_range:'',
				pcp_product_type: '',
				pcp_project_unit_no: '',
				psal_approved_date_range: ''
			},
			debouncedHandler: '',
		};
	},
	created(){
		this.fetchFilterOptions();
	},
	computed: {
		...mapState(useInitialProposalStore,['filterOptionStatus','filterOptionSSAMgr','filterOptionCC','filterOptionCH','filterOptionProductType']),
		...mapState(useAccessControlStore,['userSsaList','userList']),
	},
	methods: {
		...mapActions(useInitialProposalStore,['getFilterOptions','setFilter','clearFilter']),
		async fetchFilterOptions(){
			this.getFilterOptions()
		},
		viewFilterInitialProposal() {
			this.showDrawer = !this.showDrawer;
		},
		async searchByFilter() {
			this.setFilter(this.filters);
			initialProposalEventBus.$emit('filter-proposals');
		},
		resetFilter() {
			Object.keys(this.filters).forEach(key => {
				this.filters[key] = ''
			});
			this.clearFilter()
			this.searchByFilter()
		},
	}
}
</script>